var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"find-person"},[_c('div',{staticClass:"container-custom"},[_c('img',{staticClass:"find-person__img",attrs:{"src":require("@/assets/img/find-person-girl.png"),"alt":_vm.view.title}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.view.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }